<table  fxFlex="100" class="size-chart-table">
    <tr>
        <th *ngFor="let header of tableHeaders">{{ header }}</th>
       
      </tr>
      <tr *ngFor="let row of tabledata; let rowIndex = index">
        <ng-container *ngIf="!row.editing; else editMode">
          <td *ngFor="let header of tableHeaders">{{ row[header] }}</td>
         
        </ng-container>
        <ng-template #editMode>
          <td *ngFor="let header of tableHeaders">
            <!-- <mat-form-field appearance="outline" fxFlex> -->
            <input [(ngModel)]="row[header]" />
            <!-- </mat-form-field> -->
          </td>
         
        </ng-template>
      </tr>
   </table>